import { useState, useEffect } from 'react';

export interface FeedType {
  id: number;
  name: string;
  cost_per_kg: number;
  nutritional_value: number;
  supplier?: string;
  notes?: string;
}

export const useFeedTypes = () => {
  const [feedTypes, setFeedTypes] = useState<FeedType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFeedTypes = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/v1/feed-types');
      if (!response.ok) {
        throw new Error('Ошибка загрузки типов кормов');
      }
      const data = await response.json();
      setFeedTypes(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Неизвестная ошибка');
      console.error('Ошибка загрузки типов кормов:', err);
      
      // Fallback к статическим данным для разработки
      setFeedTypes([
        { id: 1, name: 'Отруби пшеничные', cost_per_kg: 45.0, nutritional_value: 8 },
        { id: 2, name: 'Пшеница дробленая', cost_per_kg: 32.0, nutritional_value: 9 },
        { id: 3, name: 'Жмых подсолнечника', cost_per_kg: 55.0, nutritional_value: 7 },
        { id: 4, name: 'Горох дробленый', cost_per_kg: 48.0, nutritional_value: 8 },
        { id: 5, name: 'Ячмень дробленый', cost_per_kg: 35.0, nutritional_value: 7 },
        { id: 6, name: 'Смешанный корм', cost_per_kg: 42.0, nutritional_value: 8 },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const getFeedTypeById = (id: number): FeedType | undefined => {
    return feedTypes.find(feed => feed.id === id);
  };

  const getFeedTypeByName = (name: string): FeedType | undefined => {
    return feedTypes.find(feed => feed.name.toLowerCase().includes(name.toLowerCase()));
  };

  useEffect(() => {
    fetchFeedTypes();
  }, []);

  return {
    feedTypes,
    loading,
    error,
    fetchFeedTypes,
    getFeedTypeById,
    getFeedTypeByName,
  };
};
